import { createApp } from 'vue';
import * as Sentry from '@sentry/vue';
import App from '@/App.vue';
import router from '@/router';

import type { Component } from 'vue';

const app = createApp(App as Component);

window.manifest = null;

Sentry.init({
  app,
  release: 'tour-builder@' + import.meta.env.PACKAGE_VERSION,
  dsn: 'https://055bb7f7f67932cd27c6942008511b8e@sentry.immersive.tf/2',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

app.use(router);

app.mount('#app');
